module.exports = __webpack_public_path__ + "static/banner-one-thumb-cbd00ddbd096c04b0dbca43a68687cf2.svg";